import { SignUp } from '@/screens/sign-up';

export default function SignUpScreen() {
  return <SignUp />;
}
